// extracted by mini-css-extract-plugin
module.exports = {"iframe":"styles_iframe__icixm","screenReaderOnly":"styles_screenReaderOnly__IdbF_"};